export { default } from './svg/add-outline.svg';
